<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold" id="salesModalLabel">Transactional details</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="table-responsive">
    <table class="table table-hover table-striped align-middle">
      <thead>
        <tr [tableSorter]="tableSorter" (tableSorterChange)="refresh()">
          <th tableSorterHeader="conversionDate">Date</th>
          <th>Time</th>
          <th tableSorterHeader="goalName">Goal</th>
          <th tableSorterHeader="goalTypeName">Goal Type</th>
          <th>Brand</th>
          <th>Typology</th>
          <th>Offer</th>
          <th>Promotion link</th>
          <th>Affiliate</th>
          <th tableSorterHeader="subid">SubID</th>
          <th tableSorterHeader="tc1">Tracker 1</th>
          <th tableSorterHeader="tc2">Tracker 2</th>
          <th tableSorterHeader="tc3">Tracker 3</th>
          <th tableSorterHeader="tc4">Tracker 4</th>
          <th tableSorterHeader="country">Country</th>
          <th>Revenue</th>
          <th>Payout</th>
          <th>Margin</th>
          <th>% Margin</th>
        </tr>
      </thead>
      <tbody>
        <!-- Exemple de lignes -->
        @for (conversion of conversions; track conversion) {
          <tr>
            <td>{{ conversion.date | parisDate: 'dd/MM/yyyy' }}</td>
            <td>{{ conversion.date | parisDate: 'HH:mm' }}</td>
            <td>{{ conversion.goal?.name }}</td>
            <td>{{ conversion.goalType?.name }}</td>
            <td>{{ conversion.product?.name }}</td>
            <td>{{ getSourceTypology(conversion) }}</td>
            <td>{{ conversion.offer?.name }}</td>
            <td>{{ conversion.landingPage?.name }}</td>
            <td>{{ conversion.partner?.companyName }}</td>
            <td>{{ conversion.subid }}</td>
            <td>{{ conversion.tc1 }}</td>
            <td>{{ conversion.tc2 }}</td>
            <td>{{ conversion.tc3 }}</td>
            <td>{{ conversion.tc4 }}</td>
            <td>{{ conversion.country }}</td>
            <td>{{ conversion.amount | money }}</td>
            <td>{{ conversion.payout | money }}</td>
            <td>{{ conversion.margin | money }}</td>
            <td>{{ conversion.marginPercent | percent }}</td>
          </tr>
        }
      </tbody>
    </table>

    <app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
  </div>
</div>
